<div class="viewer">

  @if (isLoaded) {
    @if (hasPermission) {
      <iframe [src]="tcmUrl">
      </iframe>
    } @else {
      <mat-toolbar>
        <span>You do not have permission for TCM. Please contact an administrator.</span>
      </mat-toolbar>
    }
  } @else {
    <busy-indicator></busy-indicator>
  }
</div>


